/* TrackBricks — page FAQ : accordeon + filtre par categorie */
(function () {
  'use strict';

  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-faq-item]');
      if (!item) return;
      var wasOpen = item.classList.contains('tb-faq__item--open');
      item.parentElement.querySelectorAll('[data-faq-item]').forEach(function (i) {
        i.classList.remove('tb-faq__item--open');
        var b = i.querySelector('[data-faq-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('tb-faq__item--open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.querySelectorAll('[data-faq-filter]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var filter = btn.getAttribute('data-faq-filter');
      document.querySelectorAll('[data-faq-filter]').forEach(function (b) {
        b.classList.remove('tb-faq__nav-btn--active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('tb-faq__nav-btn--active');
      btn.setAttribute('aria-pressed', 'true');
      document.querySelectorAll('[data-faq-category]').forEach(function (cat) {
        var show = filter === 'all' || cat.getAttribute('data-faq-category') === filter;
        cat.setAttribute('data-faq-hidden', show ? 'false' : 'true');
      });
    });
  });
})();